<template>
  <div class="content">
    <div class="md-layout">
      <div
              class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <p-s-table
                tableHeaderColor="purple"
                v-bind:title="$t('orders_title')"
                showFilter="true"
                sortBy="orderDate"
                sortOrder="desc"
                useDatePicker="true"
                v-bind:data="this.positions"
                v-bind:dict="this.positionsDict"
                v-bind:onStartDateChanged="this.onStartDateChanged"
                v-bind:onEndDateChanged="this.onEndDateChanged"
                v-bind:onFilterChanged="this.onFilterChanged"
        ></p-s-table>
      </div>
      <md-button class="md-primary" style="margin-left: auto; margin-right: 20px;" v-on:click="exportCSV()">{{ $t('export_button') }}</md-button>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import helper from '@/util/helper';
import { PSTable } from "@/components";
import api from '@/api/api';

export default {
  components: {
    PSTable
  },
  data() {
    return {
      positions: [],
      positionsDict: [
        { key: 'order', label: 'table_header_order', type: 'string'},
        { key: 'articleNumber', label: 'table_header_customer_article_number_short', type: 'string'},
        { key: 'articleDescription', label: 'table_header_customer_article_description', type: 'string'},
        { key: 'supplier', label: 'table_header_supplier', type: 'string'},
        { key: 'supplierArticleNumber', label: 'table_header_supplier_article_number', type: 'string'},
        { key: 'price', label: 'table_header_price', type: 'price'},
        { key: 'orderDate', label: 'table_header_order_date', type: 'date'},
        { key: 'confirmedDeliveryDate', label: 'table_header_delivery_date', type: 'dateTime'},
        { key: 'deliveryDate', label: 'table_header_arrival_date', type: 'dateTime'}
      ],
      startDate: new Date('2020/01/01'),
      endDate: new Date()
    }
  },
  created () {
    store.commit("setLoading", true);

    if (store.state.startDate !== null) {
      this.startDate = store.state.startDate;
    } else {
      store.commit('setStartDate', this.startDate);
    }

    if (store.state.endDate !== null) {
      this.endDate = store.state.endDate;
    } else {
      store.commit('setEndDate', this.endDate);
    }

    api.getPositions(this.startDate.toJSON(), this.endDate.toJSON()).then((result) => {
      result.data.forEach((item) => {
        item.order = item.order + "-" + item.position;
      });;

      this.positions = result.data;

      store.commit("setLoading", false);
    });
  },
  methods: {
    exportCSV() {
      let positions = store.state.positions.data;

      if (store.state.positionsFilter !== null) {
        let filter = store.state.positionsFilter;

        positions = positions.filter((position) => {
          return position.order.toString().toLowerCase().indexOf(filter) !== -1 ||
              position.articleNumber.toString().toLowerCase().indexOf(filter) !== -1 ||
              position.articleDescription.toString().toLowerCase().indexOf(filter) !== -1 ||
              position.articleId.toString().toLowerCase().indexOf(filter) !== -1 ||
              position.supplier.toString().toLowerCase().indexOf(filter) !== -1 ||
              position.supplierArticleNumber.toString().toLowerCase().indexOf(filter) !== -1;
        });
      }

      if (positions.length === 0) {
        alert("In der aktuellen Filterung sind keine Artikel verfügbar.");
        return;
      }

      helper.export(positions, "positions.csv");
    },
    onStartDateChanged(val) {
      if (val !== null && val.getTime() !== store.state.startDate.getTime()) {
        store.commit('setStartDate', val);

        this.startDate = val;

        api.getPositions(this.startDate.toJSON(), this.endDate.toJSON()).then((result) => {
          result.data.forEach((item) => {
            item.order = item.order + "-" + item.position;
          });
          this.positions = result.data;
        });
      }
    },
    onEndDateChanged(val) {
      if (val !== null && val.getTime() !== store.state.endDate.getTime()) {
        store.commit('setEndDate', val);

        this.endDate = val;

        api.getPositions(this.startDate.toJSON(), this.endDate.toJSON()).then((result) => {
          result.data.forEach((item) => {
            item.order = item.order + "-" + item.position;
          });
          this.positions = result.data;
        });
      }
    },
    onFilterChanged(val) {
      store.commit("setPositionsFilter", val);
    },
  }
};
</script>
